module.exports = __webpack_public_path__ + "user-dd606edb720ccbd76a44.svg";